export default __webpack_public_path__ + "static/media/USAvisitor.92e17ec2.jpg";